module.exports = __webpack_public_path__ + "img/Group 1083one.e3121db9.png";